import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { patientTranslationKeys } from '../translations';

type PatientActionBarProps = {
   readonly children: ReactNode;
};

export const PatientActionBar = (props: PatientActionBarProps): JSX.Element => {
   return (
      <ActionBar id='patient-action-bar' testId='patient'>
         {props.children}
         <ActionBar.GoBackActionLink
            to={patientPaths.getListPath()}
            label={patientTranslationKeys.goBackToPatientList}
         />
      </ActionBar>
   );
};
